import React from "react";
import { Operand } from "@merrie/nmbrs-api";
import { OperandComponent } from "../operand/operand.component";
import "./display-operand.component.scss";

export interface IDisplayProperties {
  operand: Operand;
}

export const DisplayOperandComponent: React.FC<IDisplayProperties> = ({
  operand,
}) => {
  const [isFocused, setFocused] = React.useState(false);
  const [mouseFocused, setMouseFocused] = React.useState(false);

  React.useEffect(() => {
    fitOperand();

    window.addEventListener("resize", fitOperand);
    return () => window.removeEventListener("resize", fitOperand);
  }, [operand]);

  const fitOperand = () => {
    const buttonElement = document.getElementsByClassName(
      "display-operand"
    )[0] as HTMLDivElement;
    const operandElement =
      buttonElement &&
      (buttonElement.querySelector(".operand") as HTMLSpanElement);

    if (!buttonElement || !operandElement) return;

    const scale = buttonElement!.offsetWidth / operandElement!.offsetWidth;

    if (scale < 1) {
      operandElement!.style.transform = `scale(${scale})`;
    } else {
      operandElement!.removeAttribute("style");
    }
  };

  return (
    <div
      tabIndex={0}
      className={`display-operand
          ${isFocused ? "display-operand-focused" : ""}
          ${isFocused && mouseFocused ? "display-operand-mouse-focused" : ""}
          ${
            isFocused && !mouseFocused ? "display-operand-keyboard-focused" : ""
          }
      `}
      onFocus={() => setTimeout(() => setFocused(true))}
      onBlur={() =>
        setTimeout(() => {
          setFocused(false);
          setMouseFocused(false);
        })
      }
      onMouseDown={() => !isFocused && setMouseFocused(true)}
      onKeyDown={() => !isFocused && setMouseFocused(false)}
    >
      <div className={"operand-container"}>
        <OperandComponent operand={operand} />
      </div>
    </div>
  );
};
